import { SearchBolder, TableColumn } from '@aon/aon-tws-common-ui';
import { ITableRowProps } from '@aon/aon-tws-common-ui/build/lib/components/Table/TableRow';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import styled from 'styled-components';
import { IColumn } from '../../../models';
import { ISurveyTemplate } from '../../../models/ISurveyTemplate';
import { FileIcon, NameLinkWrapper } from '../../common/TableLinkWrapper';

const Row = styled.tr.attrs<ITableRowProps, any>({
	className: 'tws-table-row',
})`
	&.tws-table-row.tws-table-row-selected {
		background-color: ${globalVars.mainBlue};
		color: ${globalVars.white};
		border-left: ${globalVars.spacing10} ${globalVars.borderSolid} ${globalVars.mainBlue} !important;
	}
	&.tws-table-row.tws-table-row-selected a {
		color: ${globalVars.white};
	}
	&.tws-table-row.tws-table-row-selected span {
		color: ${globalVars.white};
	}
	&.tws-table-row.tws-table-row-selected.tws-table-row tws-table-column {
		border-left: ${globalVars.spacing10} ${globalVars.borderSolid} ${globalVars.mainBlue} !important;
	}
`;
Row.displayName = 'Row';

export interface ITemplateRowProps {
	template: ISurveyTemplate;
	columns: IColumn[];
	searchText: string;
	isSelected: boolean;
	onSelect: () => void;
}

export const TemplateRow = (props: ITemplateRowProps) => {
	const className = props.isSelected ? 'tws-table-row-selected' : '';

	return (
		<Row key={props.template.surveyId} className={className}>
			<TableColumn>
				<NameLinkWrapper data-testid='name-link' onClick={() => props.onSelect()}>
					<FileIcon name='file' />
					<SearchBolder text={props.template.name} searchText={props.searchText} />
				</NameLinkWrapper>
			</TableColumn>
		</Row>
	);
};
